import React, { useEffect } from 'react';
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const ReportOptions = ({ name, isTxn, isLabel, label, isSelection, placeholder, userProps, width, callback, index, type }, props) => {

    const options = [
        { key: 1, text: 'DMS Txns - Create Date', value: 'created_date'},
        { key: 2, text: 'DMS Txns - Trans Date', value: 'trans_date' },
    
      ]

      
    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, index, placeholder }} placeholder={placeholder} width={width}> </Field>
    )

}


export default ReportOptions;